"use client";

import { useState, useEffect } from "react";
import Image from "next/image";

const PreLoader = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
    setIsLoading(true);

    const handleLoad = () => {
      setTimeout(() => {
        setIsLoading(false);
      }, 500);
    };

    if (document.readyState === "complete") {
      handleLoad();
    } else {
      window.addEventListener("load", handleLoad);
      return () => window.removeEventListener("load", handleLoad);
    }
  }, []);

  if (!mounted || !isLoading) return null;

  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-white">
      <div className="flex flex-col items-center gap-6">
        {/* Blinking Logo */}
        <div className="relative">
          <div className="animate-blink-slow">
            <Image
              src="/assets/images/Website_logo-1769951970593.png"
              alt="ARTI Enterprise Logo"
              width={120}
              height={120}
              className="h-30 w-30 object-contain"
              priority
            />
          </div>
          
          {/* Pulsing ring effect */}
          <div className="absolute inset-0 animate-ping opacity-20">
            <div className="h-full w-full rounded-full border-4 border-orange-500"></div>
          </div>
        </div>

        {/* Loading text */}
        <div className="flex flex-col items-center gap-2">
          <h2 className="text-2xl font-bold text-gray-800">ARTI Enterprise</h2>
          <p className="text-sm text-gray-600 animate-pulse">Loading...</p>
        </div>

        {/* Loading bar */}
        <div className="w-48 h-1 bg-gray-200 rounded-full overflow-hidden">
          <div className="h-full bg-gradient-to-r from-orange-500 to-orange-600 animate-loading-bar"></div>
        </div>
      </div>
    </div>
  );
};

export default PreLoader;